import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import PageHeader from "../components/PageHeader";
import Breadcrumbs, { buildBreadcrumbSchema } from "../components/Breadcrumbs";
import CTASection from "../components/CTASection";
import { newsArticles } from "../data/newsArticles";

export default function ViralTopics() {
  const breadcrumbs = [
    { label: "Home", to: "/" },
    { label: "Robot Videos", to: "/viral-robotics-topics" }
  ];
  const videoArticles = newsArticles.filter((article) => article.path && article.videos?.length).slice(0, 6);

  return (
    <>
      <SEO
        title="Robot Videos Humanoid Demos, Tests and Technical Analysis"
        description="Robot videos and humanoid demos explained through sensors, actuators, autonomy level, task conditions, failures and deployment limits."
        path="/viral-robotics-topics"
        schema={buildBreadcrumbSchema(breadcrumbs)}
      />
      <Breadcrumbs items={breadcrumbs} />
      <PageHeader
        eyebrow="Robot demos and technical context"
        title="Robot Videos"
        description="Humanoid demos, robot clips and viral robotics videos explained through visible hardware, control methods, autonomy limits and deployment conditions."
      />

      {!!videoArticles.length && (
        <section className="site-shell py-10 sm:py-14" aria-labelledby="robot-video-analysis">
          <h2 id="robot-video-analysis" className="text-3xl font-black tracking-tight text-neutral-950">Robot video analysis</h2>
          <p className="mt-3 max-w-3xl text-base leading-8 text-neutral-600">Open the original TechniaHQRobot articles for video context, technical facts and the limits hidden by short demos.</p>
          <div className="mt-6 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {videoArticles.map((article) => (
              <article key={article.path} className="soft-card soft-card-hover p-5">
                <h3 className="text-lg font-black tracking-tight text-neutral-950">
                  <Link to={article.path} className="hover:text-blue-700">{article.title}</Link>
                </h3>
                <p className="mt-3 text-sm leading-7 text-neutral-600">{article.description}</p>
              </article>
            ))}
          </div>
        </section>
      )}

      <section className="site-shell py-8 sm:py-10">
        <div className="soft-card bg-neutral-50/90 p-6">
          <h2 className="text-2xl font-bold text-neutral-950">Read the technical layer behind robot videos</h2>
          <p className="mt-3 text-sm leading-6 text-neutral-600">A robot clip becomes useful when it names the sensors, control loop, motion planning, manipulation task, deployment limit and Physical AI claim behind the demo.</p>
          <div className="mt-5 flex flex-wrap gap-3">
            <Link to="/robot-sensors" className="rounded-full bg-blue-600 px-4 py-2 text-sm font-bold text-white">Robot Sensors</Link>
            <Link to="/robotics" className="rounded-full border border-neutral-200 bg-white px-4 py-2 text-sm font-bold text-neutral-950">Robotics Guides</Link>
          </div>
        </div>
      </section>
      <CTASection title="Follow TechniaHQRobot for robot video analysis" />
    </>
  );
}
